import { Grid, Typography } from '@mui/material';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { useAccountContactType } from './hook';
import { AccountContactTypeProps } from './props';

export const AccountContactType = (props: AccountContactTypeProps) => {
    const { formik, typesContactPerson } = useAccountContactType(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Tipo contacto
                </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
                <FieldSelect
                    data={typesContactPerson}
                    label="Tipo de persona contacto"
                    name="typeContactPerson"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeContactPerson}
                    errors={formik.errors.typeContactPerson}
                    value={formik.values.typeContactPerson as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="Marque si el usuario es un cliente"
                    label="¿Es cliente?"
                    checked={Boolean(formik.values.isClient)}
                    onChange={() => {
                        formik.setFieldValue(
                            'isClient',
                            !formik.values.isClient
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="Utilización datos contacto"
                    label="Habeas data"
                    checked={Boolean(formik.values.acceptsHabeasData)}
                    onChange={() => {
                        formik.setFieldValue(
                            'acceptsHabeasData',
                            !formik.values.acceptsHabeasData
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
        </Grid>
    );
};
